<template lang="pug">
.single-question
  Form(:model="question")
      .question-stem
        Button(icon="md-add",style='color:#3A76D2;border: 1px solid #3A76D2;margin-left: 12px;transform: translateY(-10px);',
          @click='showAIDialog()',v-if='enableAI') AI生成
        Modal(v-model="aiDialogVisible" title="AI生成" @on-ok="generateCase")
          Form(:model="aiForm" :label-width="80")
            FormItem(label="生成数量")
              InputNumber(v-model="aiForm.count" :min="1" :max="10" placeholder="请输入生成数量")
            FormItem(label='提示词',prop="stem")
              Input(v-model='aiForm.system' placeholder='请填写提示词'
                type="textarea" :rows="3")
        FormItem
          Input(type='text',placeholder='题目内容',v-model='question.stem')
        iDelModel(:del-model='delModel',@upData="$emit('upData')",@downData="$emit('downData')")
      .question-tips(v-show='question.showTips')
        FormItem
          Input(type='text',placeholder='编辑提示信息',v-model='question.tips')
      .question-metas
        FormItem(v-for='(item,index) in question.metas',
            :label='"#选项"+(index+1)',
            label-position="right",
            :label-width="80",
            :key='index')
          Input(type='text',v-model='question.metas[index]')
          Icon(type="ios-close-circle",@click='delMeta(index)' v-if='index!==0')
      .question-addBtn
        FormItem(label-position='right' :label-width="80")
          Button.btn(@click='addMeta') + 添加
      .question-answer
        FormItem(label='正确答案',label-position="right",:label-width="80")
          RadioGroup(v-model='question.answer')
            Radio(v-for='(item,index) in question.metas',
            :label='index',
            :key='index')
              span 选项{{index+1}}
      .question-analysis
        FormItem(label='答案解析',label-position="right",:label-width="80")
          Input(type='textarea',v-model='question.analysis',:rows="3")
      .question-score
        FormItem(label='分值',label-position="right",:label-width="80")
          InputNumber(:max='100',:min='0',v-model='question.score')
      .question-edit
        isEditTips(:is-edit='question.showTips' :event='editTips')
</template>
<script>
import iDelModel from "@/components/common/iDelModel";
import isEditTips from "@/components/common/iEditTips";
import Bus from "../../utils/bus";
export default {
  components: {
    iDelModel,
    isEditTips
  },
  props: ["data", "haId", "taskId", "enableAI"],
  data() {
    return {
      question: {
        metas: ["", "", ""],
        answer: "",
        tips: "",
        stem: "",
        analysis: "",
        showTips: false,
        score: 0
      },
      aiDialogVisible: false,
      aiForm: {}
    };
  },
  methods: {
    showAIDialog() {
      this.aiDialogVisible = true;
      this.aiForm = { count: 1, system: "" };
    },
    generateCase() {
      if (this.taskId === "" || this.taskId === null || this.taskId === undefined) {
        this.$Message.error("无法生成！原因：需先保存当前场景！");
        return;
      }
      const data = {
        inputs: {
          opt_type: "SINGLECHOICE",
          count: this.aiForm.count,
          pyId: this.$store.state.Case.basic.id,
          tsId: this.taskId,
          haId: this.haId,
          score: 2,
          system: this.aiForm.system
        }
      };

      this.$http.generateCase(data).then((res) => {
        if (res.data.success) {
          this.$Message.success("保存成功");
          if (this.taskId !== this.haId) {
            Bus.$emit("refresh-task", this.taskId);
          } else {
            this.$emit("refresh-query");
          }
        }
      });
    },
    addMeta() {
      // 添加选项
      this.question.metas.push("");
    },
    delMeta(x) {
      // 删除选项
      if (this.question.metas.length > 2) {
        this.question.metas.splice(x, 1);
      } else {
        return this.$Message.error("至少保留两条选项");
      }
    },
    editTips() {
      // 编辑提示
      this.question.showTips = !this.question.showTips;
    },
    delModel() {
      this.$emit("delModel");
    }
  },
  mounted() {
    console.log("sss", this.enableAI);
    this.$nextTick(() => {
      if (Object.keys(this.data).length !== 0) {
        this.question = this.data;
      }
      //   this.$emit("data1:data", this.question);
    });
  },
  watch: {
    question: {
      handler(val) {
        if (JSON.stringify(val) !== JSON.stringify(this.data)) {
          this.$emit("data1:data", val);
        }
      },
      deep: true,
      immediate: false // 初始时触发
    },
    data: {
      handler(val) {
        if (JSON.stringify(val) !== "{}") this.question = val; // 更新本地变量
      },
      immediate: true,
      deep: true
    }
  }
};
</script>

<style lang="stylus" scope>
.single-question
  width 790px
  padding 24px 16px 24px 44px
  .question-stem
    position relative
    .ivu-form-item-content
      width 75%
  .question-metas
    .ivu-form-item-content
      margin-right 25px
      position relative
      .ivu-input
        margin 0
      .ivu-icon-ios-close-circle
        font-size 22px
        position absolute
        top 6px
        color #E72020FF
        &:hover
          cursor pointer
  .question-analysis
    textarea
      resize none
  .question-addBtn
    .btn
      width 100px
      height 32px
</style>
